(function attachJiecProductDiscoveryCore(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.JiecProductDiscoveryCore = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function createJiecProductDiscoveryCore() {
  const needEntries = Object.freeze([
    ['dryness', 'Dryness'],
    ['glow', 'Glow'],
    ['sensitive-skin', 'Sensitive skin'],
    ['body-care', 'Body care'],
    ['hair-care', 'Hair care'],
    ['youthful-skin', 'Youthful Skin'],
    ['deep-nourishment', 'Deep Nourishment'],
  ]);

  const needsBySlug = new Map(needEntries);
  const slugsByNeed = new Map(needEntries.map(([slug, need]) => [need, slug]));

  function normalizeNeed(need) {
    return slugsByNeed.has(need) ? need : 'all';
  }

  function readNeedFromSearch(search) {
    const slug = new URLSearchParams(search).get('best-for');
    return needsBySlug.get(slug) || 'all';
  }

  function slugForNeed(need) {
    return slugsByNeed.get(normalizeNeed(need)) || '';
  }

  function updateSearch(search, need) {
    const searchParams = new URLSearchParams(search);
    const slug = slugForNeed(need);

    if (slug) {
      searchParams.set('best-for', slug);
    } else {
      searchParams.delete('best-for');
    }

    const serialized = searchParams.toString();
    return serialized ? `?${serialized}` : '';
  }

  function normalizeSearchTerm(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function readProductSearchFromSearch(search) {
    return new URLSearchParams(search).get('product-search') || '';
  }

  function updateProductSearch(search, query) {
    const searchParams = new URLSearchParams(search);
    const normalizedQuery = String(query || '').trim().replace(/\s+/g, ' ');

    if (normalizedQuery) {
      searchParams.set('product-search', normalizedQuery);
    } else {
      searchParams.delete('product-search');
    }

    const serialized = searchParams.toString();
    return serialized ? `?${serialized}` : '';
  }

  function matchesSearch(value, query) {
    const normalizedQuery = normalizeSearchTerm(query);
    return !normalizedQuery || normalizeSearchTerm(value).includes(normalizedQuery);
  }

  function parseNeeds(value) {
    return String(value || '')
      .split('|')
      .map((need) => need.trim())
      .filter((need) => slugsByNeed.has(need));
  }

  function matchesNeed(value, activeNeed) {
    const normalizedNeed = normalizeNeed(activeNeed);
    return normalizedNeed === 'all' || parseNeeds(value).includes(normalizedNeed);
  }

  function filterRecords(records, activeNeed) {
    return records.filter((record) => matchesNeed(record.needs, activeNeed));
  }

  return Object.freeze({
    needEntries,
    normalizeNeed,
    readNeedFromSearch,
    slugForNeed,
    updateSearch,
    normalizeSearchTerm,
    readProductSearchFromSearch,
    updateProductSearch,
    parseNeeds,
    matchesNeed,
    matchesSearch,
    filterRecords,
  });
});
